(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CampaignController', campaignController)

  campaignController.inject = ['$scope', 'ngTableParams', '$http', 'LangService', 'CampaignService', 'NotificationService']

  function campaignController ($scope, ngTableParams, $http, LangService, CampaignService, NotificationService) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'menu.config.campaign' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    vm.searchCampaignTable = searchCampaignTable;
    vm.downloadReport = downloadReport;
    vm.downloadUploadedFile = downloadUploadedFile;

    searchCampaignTable();

    function searchCampaignTable () {
      vm.campaignTable = new ngTableParams({
        page: 1, // show first page
        count: 10 // count per page
      }, {
        counts: [25, 50, 100],
        getData: function ($defer, params) {
          var obj = params.url();

          CampaignService
            .getAll(obj)
            .$promise
            .then(function (data) {
              $defer.resolve(data.campaigns);
              params.total(data.total);
              if (!data.campaigns) {
                NotificationService.errorHandler(data, vm.labelsPage.errorCampaign);
              }
            }).catch(function (data) {
              NotificationService.errorHandler(data, vm.labelsPage.errorCampaign);
              vm.totalLang = 0;
            });
        }
      });
    }

    function downloadReport (campaign) {
      $http.get(apiUrl + '/reports/common/Campaign', {
        params: {
          filters: {
            companyId: $scope.user_data.company_id,
            fromDate: moment().startOf('month').format('DD/MM/YYYY'),
            toDate: moment().endOf('month').format('DD/MM/YYYY'),
            status: '',
            specific: true,
            campaign_id: campaign._id
          }
        }
      })
        .then(function ({ data, status, headers }) {
          if (data.success === false) {
            NotificationService.errorHandler(data, vm.labelsPage.noRecordFound);
            return;
          }

          var filename = headers('Mktzap-Filename');

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' }); // Make sure it's not visible
          angular.element(document.body).append(anchor); // Attach to document

          var blob = new Blob([data], { type: 'text/csv' });
          var csvUrl = URL.createObjectURL(blob);

          anchor.attr({
            href: csvUrl,
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove(); // Clean it up afterwards
          URL.revokeObjectURL(csvUrl); // Clean memory blob
        }, function ({ data, status, headers, config }) {
          $http.get(apiUrl + '/reports/common/Campaign', {
            params: {
              filters: {
                companyId: $scope.user_data.company_id,
                reportTitle: vm.labelsPage.reportTitle,
                fromDate: moment().startOf('month').format('DD/MM/YYYY'),
                toDate: moment().endOf('month').format('DD/MM/YYYY'),
                status: '',
                extraParams: { campaign_id: campaign._id },
                specific: true,
                sendByEmail: true,
                typeReport: 9
              }
            }
          })
            .then(function ({ data }) {
              if (data.success) {
                NotificationService.warningHandler(null, vm.labelsPage.alertProcessMail);
              }
            }, function ({ data }) {
              NotificationService.errorHandler(data, vm.labelsPage.errorReport);
            })
        })
    }

    function downloadUploadedFile (campaign) {
      var obj = {
        'imported_file_id': campaign.file.id
      };

      CampaignService
        .getImportedFileUrl(obj)
        .$promise
        .then(function (data) {
          if (data.success) {
            var link = document.createElement('a');

            link.setAttribute('href', data.url);
            link.setAttribute('download', campaign.file.name);
            link.setAttribute('target', '_blank');

            document.body.appendChild(link);

            link.click();
          }
        });
    }
  }
})();
